// extracted by mini-css-extract-plugin
export default {"title":"agentInsurance_title__ir57U","number":"agentInsurance_number__A3oDz"};